export default "__VITE_ASSET__597eff0c__"